import React from 'react';
import styled, { keyframes } from 'styled-components';

import levels from 'src/data/floorplates/levels';
import floorplans from 'src/data/floorplans';

const handleClick = (unit, onClick) => {
  onClick(unit);
};

const Floorplate = ({ type, active, filter, onClick }) => (
  <svg
    width="667px"
    height="667px"
    viewBox="0 0 667 667"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <G
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      key={active}
    >
      {levels[active].outline}
      {levels[active].units.map((unit, index) => (
        <G
          key={index}
          soldout={floorplans[unit.id].soldout}
          onClick={() => handleClick(unit.id, onClick)}
          active={
            (type === 0 && filter === floorplans[unit.id].bed) ||
            (type === 0 && filter === 4) ||
            (type === 1 && filter === 0 && floorplans[unit.id].bed === 3) ||
            (type === 1 &&
              filter === 1 &&
              floorplans[unit.id].bed === 3 &&
              floorplans[unit.id].flex) ||
            (type === 1 &&
              filter === 2 &&
              floorplans[unit.id].bed === 3 &&
              floorplans[unit.id].family) ||
            (type === 1 && filter === 3)
          }
        >
          {unit.mockup}
        </G>
      ))}
    </G>
  </svg>
);

const animateShow = keyframes`
  0% {
    display: none;
    opacity: 0;
  }
  1% {
    display: block;
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const G = styled.g`
  cursor: pointer;
  animation: ${animateShow} 0.4s ease-out forwards;
  g > polygon,
  g > path,
  g > polyline {
    fill-opacity: ${(props) => (props.active ? 1 : 0)};
    transition: all 0.4s ease-out;
  }
  &.filter {
    g > polygon,
    g > path,
    g > polyline {
      fill-opacity: 1;
      transition: all 0.4s ease-out;
    }
  }
  #no-hover {
    cursor: auto;
  }
  text {
    text-decoration: ${(props) => (props.soldout ? 'line-through' : 'none')};
    opacity: ${(props) => (props.soldout ? 0.4 : 1)};
    fill: ${(props) => (props.soldout ? '#231f20' : '#F58220')};
  }
`;

export default Floorplate;



// WEBPACK FOOTER //
// ./src/pages/Floorplans/elements/Floorplate.js